import React, { useState } from 'react';
import styled from 'styled-components';
import BsgLogo from '../assets/icons/BSG LogoWhite.svg';
import {
  CenteredContainer,
  Heading,
  StyledText,
  sharedStyles,
} from '../components/Typography';
import Button from '../components/Button';
import OTPInput from '../components/OTPInput';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../components/Routes/index';
import { post } from '../components/ApiHandler/apihandler';
import { SERVICES } from '../components/Services';
import CancelButton from '../components/Button/CancelButton';
import { toast } from 'react-toastify';
import ForgotScreenBG from '../assets/images/Forgot-Screen-BG.png';
import { Helmet } from 'react-helmet';

const MainContainer = styled.div`
  background-image: url(${ForgotScreenBG});
  display: flex;
  justify-content: center;
  background-position: 0px -273px;
  background-size: 100%;
  background-attachment: fixed;
`;

const RightContainer = styled.div`
  width: 70%;
  background: #fff;
  @media (max-width: 767px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
`;
const RightContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  @media (max-width: 767px) {
    margin-top: 25;
  }
`;

const OtpContainer = styled.div`
  width: 95%;
  height: fit-content;
  margin-top: 75px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 767px) {
    margin: 0px;
    margin-top: 15px;
    padding: 0px 15px;
    box-sizing: border-box;
  }
`;
const OtpContent = styled.p`
  ${sharedStyles}
`;
const ImpTextContainer = styled.div`
  width: 95%;
  height: fit-content;
  background: #fff;
  margin-top: 25px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
`;
const ImpText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 135%;
  color: #404040;
  padding: 0px;
  margin: 0;
  text-align: center;
`;
const NoticeText = styled.p`
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #c30000;
  white-space: pre-wrap;
  padding: 0px 20px;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;

const HandleCancelButtonStyles = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: ${(props) => props.marginBottom || '0px'};
  @media (max-width: 767px) {
    margin-top: 10px;
    margin-bottom: 0px;
  }
`;

const CenteredContainermsg = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
  width: 65%;
  @media (max-width: 767px) {
    margin-top: 10px;
    margin-bottom: 0px;
  }
  @media (max-width: 640px) {
    width: 95%;
  }
`;
const HandleSubmitButtonStylesbox = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: ${(props) => props.marginBottom || '0px'};
`;
const HandleSubmitButtonStyles = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
  align-items: flex-end;
  margin-right: 15px;
  margin-bottom: ${(props) => props.marginBottom || '0px'};
`;

const OtpAuthenticationpage = () => {
  const navigate = useNavigate();
  const [Otp, setOtp] = useState('');
  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
  };
  const TITLE = 'Enter OTP - BSG Contribution Site';
  const handleMfaSubmit = async () => {
    const url = SERVICES.OTP_AUTHENTICATION;

    try {
      const response = await post(url, { mfaCode: Otp });

      if (response.ok) {
        navigate(ROUTES.HOME);
      } else {
        toast.error(`MFA Failed`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        });
      }
    } catch (error) {
      toast.error(`${error?.message}`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };
  const handleCancel = () => {
    localStorage.removeItem('X-Auth-Token');
    navigate(-1);
  };
  return (
    <MainContainer>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <RightContainer>
        <RightContainerContent>
          <img style={{ width: '80px' }} src={BsgLogo} alt="/Logo" />
          <CenteredContainer style={{ marginTop: '10px', marginBottom: '0px' }}>
            <Heading>Enter OTP</Heading>
          </CenteredContainer>

          <StyledText
            fontWeight="600"
            Size="20px"
            color="#009cbf"
            style={{ marginTop: '0px' }}
          >
            (One-time password)
          </StyledText>
          <CenteredContainermsg
            style={{ marginLeft: 'auto', marginRight: 'auto' }}
          >
            <StyledText
              style={{
                color: '#c30000',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontSize: '15px',
                fontWeight: '500',
                margin: '0',
                lineHeight: 'normal',
                textAlign: 'center',
              }}
            >
              One-time password (OTP) has been sent to your email id and mobile
              number registered in BDS.
            </StyledText>
          </CenteredContainermsg>
          <OTPInput onOTPChange={handleOTPChange} />

          <HandleSubmitButtonStylesbox>
            <HandleSubmitButtonStyles onClick={handleMfaSubmit}>
              <Button>Submit</Button>
            </HandleSubmitButtonStyles>
            <HandleCancelButtonStyles onClick={handleCancel}>
              {/* <Button>Cancel</Button> */}
              <CancelButton>Cancel</CancelButton>
            </HandleCancelButtonStyles>
          </HandleSubmitButtonStylesbox>
          <ImpTextContainer>
            <ImpText>
              <span style={{ fontSize: '15px', color: '#009cbf' }}>
                Important -
              </span>{' '}
              If you do not receive the OTP within 4-5 mins, Please contact your
              District Stats-Incharge to check if the e-mail ID and mobile
              number registered with BSG are correct.
            </ImpText>
          </ImpTextContainer>
        </RightContainerContent>
        <OtpContainer>
          <StyledText fontWeight="700" Size="16px">
            What is OTP?
          </StyledText>
          <OtpContent
            style={{ color: '#383838', fontSize: '15px', fontWeight: '500' }}
          >
            OTP is an additional verification required to log in to the Online
            Contribution website, for increased security and safety. This code
            can be generated by clicking the “Generate OTP” link given above.
            The code will be sent as an e-mail to your e-mail ID and as an SMS
            to your mobile number, which are registered with BSG. OTP is valid
            for 10 minutes only after it is generated.
          </OtpContent>
        </OtpContainer>

        <CenteredContainer
          style={{
            width: '95%',
            marginLeft: 'auto',
            marginRight: 'auto',
            background: '#ffdede',
          }}
        >
          <NoticeText>
            “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR
            MAKING CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES
            CONTRIBUTION THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR
            CONTRIBUTION.”
          </NoticeText>
        </CenteredContainer>
      </RightContainer>
    </MainContainer>
  );
};

export default OtpAuthenticationpage;
